<template>
	<div class="section">
		<div class="container">
			<div class="columns">
				<div class="column is-8 is-offset-2">
					<h2>Contact Us</h2>
					<br />
					<div v-if="!sent">
						<b-field label="Contact Type">
							<b-select v-model="category" placeholder="Select a category" data-selected="'Regular'">
								<option v-for="opt in categories" :value="opt" :key="opt">{{opt}}</option>
							</b-select>
						</b-field>
						<div class="breathe-sm">
							<b-field label="First Name">
								<b-input v-model="contact.firstname" placeholder="First Name"></b-input>
							</b-field>
						</div>
						<div class="breathe-sm">
							<b-field label="Last Name">
								<b-input v-model="contact.lastname" placeholder="Last Name"></b-input>
							</b-field>
						</div>
						<div class="breathe-sm">
							<b-field label="Email">
								<b-input v-model="contact.email" placeholder="Email Address" type="email"></b-input>
							</b-field>
						</div>
						<div class="breathe-sm">
							<b-field label="Organisation / Group">
								<b-input v-model="contact.group" placeholder="Organisation / Group"></b-input>
							</b-field>
						</div>
						<div class="breathe-sm">
							<b-field label="Message">
								<b-input v-model="contact.message" type="textarea" maxlength="500"></b-input>
							</b-field>
						</div>
						<div class="breathe-sm">
							<button type="button" :disabled="sent" class="button is-primary" @click="submit" :class="{'is-loading': sending}">Submit</button>
						</div>
					</div>
					<div v-if="sent">
						<h4>Thank you, We've received your message!</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				type: 'general',
				contact: {
					category: 'General Inquiry'
				},
				categories: ["Comments", "General Inquiry", "Technical Inquiry"],
				sending: false,
				sent: false
			}
		},
		computed: {
			category() {
				var self = this;
				if (self.type == 'technical')
					return 'Technical Inquiry';
				else if (self.type == "general")
					return "General Inquiry";
				else
					return "Comments";

			},
		},
		methods: {
			submit() {
				if (this.contact.firstname && this.contact.lastname && this.contact.email && this.contact.group && this.contact.message) {
					this.contact.category = this.category;
					this.sending = true;
					this.$http.post('api/mail/contact', this.contact).then((resp) => {
						this.sending = false;
						this.sent = true;
					}).catch(err => {
						this.sending = false;
						this.sent = false;
						this.$buefy.toast.open({
							duration: 4000,
							type: 'is-error',
							message: "An issue occurred and the message was not sent."
						});
					});
				}
				else {
					this.$buefy.toast.open({
						duration: '4000',
						type: 'is-error',
						message: "Please fill out all forms."
					});
				}
			}
		},
		mounted() {

			this.$set(this.contact, 'email', this.$store.getters.user.Email || this.$store.getters.user.Username);

			if (this.$store.getters.user && this.$store.getters.user.GroupNames) {
				this.contact.group = this.$store.getters.user.GroupNames.join(", ");
			}

			if (this.$store.getters.user) {
				this.contact.firstname = this.$store.getters.user.FirstName;
				this.contact.lastname = this.$store.getters.user.LastName;
			}

			//this.refreshCategory();
		}
	}
</script>
